import routes from './activePlaces.routes';

export const activePlacesModule = {
    routes
};